import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SidebarService } from '@ibe/services/ui';
import * as moment from 'moment';
import { EQUIPMENT_CODE_BUS, EXTRAS_ANCILLARY_CARBON_OFFSET, EXTRAS_ANCILLARY_BOOKING_HOTEL, EXTRAS_ANCILLARY_SEAT, ANCILLARY_PRODUCT_LOUNGE, ANCILLARY_PRODUCT_FAST_TRACK, ANCILLARY_PRODUCT_SEAT, ANCILLARY_PRODUCT_MEAL, EXTRAS_ANCILLARY_ANIMAL, EXTRAS_ANCILLARY_MUSICAL, EXTRAS_ANCILLARY_EQUIPMENT, EXTRAS_ANCILLARY_BAG, SSR_CODE_BAGGAGE_ADDITIONAL_BAG, ANCILLARY_PRODUCT_PACKS, TRANSLATION_INSURANCE } from '@ibe.config';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { INDRAFlightPriceService } from '@ibe.services/flight-price.indra.service';
import * as _ from 'lodash';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAAncillariesService } from '@ibe.services/ancillaries.indra.service';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRABookedTripDetails, INDRAExternalReservation } from '@ibe.models/booked-trip-details.indra.model.lib';



@Component({
	selector: 'app-booking-price-breakdown-view',
	templateUrl: './booking-price-breakdown-view.indra.component.html',
	styleUrls: ['./booking-price-breakdown-view.component.scss']
})
export class INDRABookingPriceBreakdownViewComponent implements OnInit, OnDestroy {

	/* USED */
	booked_trip;
	ancillaries: any = [];
	paidThirdPartyAncillaries: any = [];
	extra_stopover: Array<any> = [];
	flight_tickets = [];
	isAwardTicket: boolean = false;
	isTaxSidebarByPNR;
	discounts = [];
	airlineLogo;
	currency: string;
	currencyCode: string = '';
	pnr: string;
	// hasBoughtPartnerExtras: boolean = false;
	boughtHotelBookingExtras: any = [];
	boughtCarbonOffsetExtra: INDRAExternalReservation;
	carbonOffsetCurrency: any;
	boughtDanishFundExtra: INDRAExternalReservation;
	danishFundCurrency: any;
	boughtTravelInsuranceExtra: INDRAExternalReservation;
	insuranceCurrency: any;
	translationInsurance = TRANSLATION_INSURANCE;
	boughtCarRentalExtra: INDRAExternalReservation;
	carRentalCurrency: any;
	carRentalCity: any;

	adminFee = 0;
	surchargeAmount = 0;

	STOPOVER_LINKS = [
		{
			id: 'hotel',
			label: 'Hotel',
			description: '',
			type: 'extra',
			action: { label: 'Add', route: 'partner-hotel' },
			icon: 'destinations--adventure',
			active: false
		},
		{
			id: 'lisboa-card',
			label: 'Lisboa card discount voucher',
			description: '',
			type: 'extra',
			action: { label: 'Add', route: 'lisboa-card-discount' },
			icon: 'services--book_hotel',
			active: false
		},
		{
			id: 'sightseeing-tours',
			label: 'Sightseeing tours',
			description: '',
			type: 'extra',
			action: { label: 'Add', route: 'sightseeing-tours' },
			icon: 'destinations--tours_activities',
			active: false
		},
		{
			id: 'airport-transfers',
			label: 'Airport transfers',
			description: '',
			type: 'extra',
			action: { label: 'Add', route: 'airport-transfers' },
			icon: 'transportation--bus',
			active: false
		},
		{
			label: 'Download Stopover app',
			description: '',
			type: 'extra',
			details: { label: 'Learn More', route: 'sports-equipment' },
			icon: 'digital_universe--mobile_phone',
			active: false
		},
		{
			label: '',
			description: '',
			type: 'extra',
			icon: null,
			details: {
				label: 'All Stopover Experiences and Discounts',
				route: 'ancillaries--sports_equipment'
			}
		}
	];
	// isAlive: boolean;

	constructor(
		protected sidebarService: SidebarService,
		protected route: ActivatedRoute,
		private currencyService: INDRACurrencyService,
		private bookingSearchService: INDRABookingSearchService,
		private flightPriceService: INDRAFlightPriceService,
		protected bookingService: INDRABookingService,
		protected ibeAdminService: INDRAIbeAdminService,
		protected ancillariesService: INDRAAncillariesService,
		private bfmStorage: INDRABFMDataStorageService
	) { }

	ngOnInit() {
		this.isTaxSidebarByPNR = this.route.snapshot.paramMap.get('isTaxSidebarByPNR');

		this.currency = this.currencyService.INDRA_getCurrencySymbol().unit;
		this.currencyCode = this.currencyService.INDRA_getCurrencySymbol().name;
		this.pnr = this.route.snapshot.paramMap.get('pnr');
		this.booked_trip = this.bfmStorage.INDRA_getActiveBookedTrip();
		this.INDRA_setBoughtPartnerExtras();
		this.flight_tickets = this.bfmStorage.INDRA_getFlightTickets();
		this.isAwardTicket = this.INDRA_isMilesLoyaltyProgramAwardTicket();
		this.discounts = this.INDRA_getDiscounts(this.booked_trip.discounts);
		this.adminFee = this.INDRA_getAdminFee(this.booked_trip);
		this.surchargeAmount = this.INDRA_getSurchargeAmount(this.booked_trip);

		this.bookingSearchService.INDRA_generateTemporaryPNR().subscribe(res => {
			if (res && res.data) {
				this.booked_trip = new INDRABookedTripDetails(res);
				this.INDRA_setPriceBreakdownDetails();
			}
		})

	}

	ngOnDestroy() {
		// this.isAlive = false;
	}

	/* START PRICE BREAKDOWN BOOKING VIEW */

	INDRA_setPriceBreakdownDetails() {
		const itemsAdded = this.INDRA_getAncillaries();

		if (itemsAdded.length) {
			const ancillariesTemp = [];
			for (const i in itemsAdded) {
				let destination;
				const ancillaryDetail = this.ancillariesService.INDRA_getAncillaryConfig(itemsAdded[i].type);
				const flight = this.INDRA_getFlightDetails(this.flight_tickets, itemsAdded[i]);
				const hasStopover = this.bookingSearchService.INDRA_hasStopover(this.booked_trip);
				const activeBooking = this.bfmStorage.INDRA_getActiveBookedTrip();
				if (hasStopover) {
					if (itemsAdded[i].type === ANCILLARY_PRODUCT_LOUNGE || itemsAdded[i].type === ANCILLARY_PRODUCT_FAST_TRACK || itemsAdded[i].type === ANCILLARY_PRODUCT_SEAT || itemsAdded[i].type === ANCILLARY_PRODUCT_MEAL || (ANCILLARY_PRODUCT_PACKS.includes(itemsAdded[i].type) && !itemsAdded[i].flightBased)) {

						if (flight.idFlight === parseInt(itemsAdded[i].flightId)) {
							const ancillarySegment = flight.listSegment.find(segment => segment.idInfoSegment === parseInt(itemsAdded[i].segmentId));

							if (ancillarySegment) {
								destination = `${activeBooking.translate.locations[ancillarySegment.departureAirport].city} - ${activeBooking.translate.locations[ancillarySegment.arrivalAirport].city}`;
							} else {
								const stopoverDetails = this.bookingService.INDRA_getBookedFlight(itemsAdded[i].flightCardId);
								if (stopoverDetails) {
									destination = `${activeBooking.translate.locations[stopoverDetails.listSegment[0].departureAirport].city} - ${activeBooking.translate.locations[stopoverDetails.listSegment[0].arrivalAirport].city}`;
								}
							}
						}

					} else {
						// for flight-based
						const flightsList = _.cloneDeep(this.flight_tickets);
						const stopoverIdx = flightsList.findIndex(element => element.type === 'stopover');
						flightsList.splice(stopoverIdx, 1);
						for (let x = 0; x < flightsList.length; x++) {


							if (flightsList[x].item.arrivalLocation.code == flight.lastSegment.arrivalAirport &&
								flightsList[x].item.departureLocation.code == flight.firstSegment.departureAirport) {
								destination = x + 1 == flightsList.length ? `${flightsList[x].item.departureLocation.city} - ${flightsList[x].item.arrivalLocation.city}` : `${flightsList[x].item.departureLocation.city} - ${flightsList[x + 1].item.arrivalLocation.city}`;
								break;
							}

						}
					}
				} else {
					let arr: any;
					if (itemsAdded[i].type === ANCILLARY_PRODUCT_LOUNGE || itemsAdded[i].type === ANCILLARY_PRODUCT_FAST_TRACK ||
						itemsAdded[i].type === ANCILLARY_PRODUCT_SEAT || itemsAdded[i].type === ANCILLARY_PRODUCT_MEAL ||
						(ANCILLARY_PRODUCT_PACKS.includes(itemsAdded[i].type) && !itemsAdded[i].flightBased)) {
						const ancillarySegment = flight.listSegment.find(segment => segment.idInfoSegment === parseInt(itemsAdded[i].segmentId));
						destination = `${activeBooking.translate.locations[ancillarySegment.departureAirport].city} - ${activeBooking.translate.locations[ancillarySegment.arrivalAirport].city}`;

					} else {
						// for flight-based
						const origin = this.bookingService.INDRA_getLocation(flight.firstSegment.departureAirport);
						arr = this.bookingService.INDRA_getLocation(flight.lastSegment.arrivalAirport);
						destination = `${origin.city} - ${arr.city}`;
					}

				}

				let isPack = false;
				if (
					ANCILLARY_PRODUCT_PACKS.includes(itemsAdded[i].type)
				) {
					isPack = true;
				}

				const ancillaryDetails = {
					name: ancillaryDetail.name,
					quantity: itemsAdded[i].type !== EXTRAS_ANCILLARY_SEAT ? itemsAdded[i].quantity : 1,
					destination: destination,
					cost: itemsAdded[i].price.toString(),
					link: ancillaryDetail.action.route,
					flight: flight,
					icon: ancillaryDetail.icon,
					flightId: itemsAdded[i].flightId,
					segmentId: itemsAdded[i].segmentId,
					type: itemsAdded[i].type,
					payWithMiles: itemsAdded[i].points ? true : false,
					points: itemsAdded[i].points ? itemsAdded[i].points : 0,
					currency: this.currencyService.INDRA_getCurrencySymbol(itemsAdded[i].currency).unit,
					flightCardId: itemsAdded[i].flightCardId,
					code: itemsAdded[i].code,
					paxId: itemsAdded[i].paxId,
					emdTicket: itemsAdded[i].emdTicket,
					ssrTatto: itemsAdded[i].ssrTatto,
					translation: ancillaryDetail.translation,
					isPack: isPack,
					flightBased: itemsAdded[i].flightBased,
				};
				if (this.ancillaries && this.ancillaries.length == 0) {
					this.ancillaries.push(ancillaryDetails);
					ancillariesTemp.push(ancillaryDetails);
				} else {
					let found = false;
					for (const x in this.ancillaries) {
						if (this.ancillaries[x].type == ancillaryDetails.type &&
							this.ancillaries[x].destination == ancillaryDetails.destination) {
							// this.ancillaries[x].cost = parseFloat(this.ancillaries[x].cost) + parseFloat(ancillaryDetails.cost);
							// this.ancillaries[x].points = parseInt(this.ancillaries[x].points) + parseInt(ancillaryDetails.points);
							found = true;

							// additional logic to group flight-based ancillaries
							if (this.ancillaries[x].type === EXTRAS_ANCILLARY_ANIMAL && ancillaryDetails.type === EXTRAS_ANCILLARY_ANIMAL) {
								if ((ancillariesTemp.filter(anc => anc.type === EXTRAS_ANCILLARY_ANIMAL && anc.destination == ancillaryDetails.destination).length > 0) &&
									(ancillariesTemp.filter(anc => anc.type === EXTRAS_ANCILLARY_ANIMAL && anc.paxId == ancillaryDetails.paxId &&
										anc.destination == ancillaryDetails.destination).length == 0)) {
									this.ancillaries[x].quantity = this.ancillaries[x].quantity + ancillaryDetails.quantity;
									this.ancillaries[x].cost = parseFloat(this.ancillaries[x].cost) + parseFloat(ancillaryDetails.cost);
									this.ancillaries[x].points = parseInt(this.ancillaries[x].points) + parseInt(ancillaryDetails.points);
								}
								ancillariesTemp.push(ancillaryDetails);
							}
							else if (this.ancillaries[x].type === EXTRAS_ANCILLARY_EQUIPMENT && ancillaryDetails.type === EXTRAS_ANCILLARY_EQUIPMENT) {
								if ((ancillariesTemp.filter(anc => anc.type === EXTRAS_ANCILLARY_EQUIPMENT && anc.destination == ancillaryDetails.destination).length > 0) &&
									(ancillariesTemp.filter(anc => anc.type === EXTRAS_ANCILLARY_EQUIPMENT && anc.paxId == ancillaryDetails.paxId &&
										anc.code == ancillaryDetails.code && anc.destination == ancillaryDetails.destination).length == 0)) {
									this.ancillaries[x].quantity = this.ancillaries[x].quantity + ancillaryDetails.quantity;
									this.ancillaries[x].cost = parseFloat(this.ancillaries[x].cost) + parseFloat(ancillaryDetails.cost);
									this.ancillaries[x].points = parseInt(this.ancillaries[x].points) + parseInt(ancillaryDetails.points);
								}
								ancillariesTemp.push(ancillaryDetails);
							}
							else if (this.ancillaries[x].type === EXTRAS_ANCILLARY_MUSICAL && ancillaryDetails.type === EXTRAS_ANCILLARY_MUSICAL) {
								if ((ancillariesTemp.filter(anc => anc.type === EXTRAS_ANCILLARY_MUSICAL && anc.destination == ancillaryDetails.destination).length > 0) &&
									(ancillariesTemp.filter(anc => anc.type === EXTRAS_ANCILLARY_MUSICAL && anc.paxId == ancillaryDetails.paxId &&
										anc.code == ancillaryDetails.code && anc.destination == ancillaryDetails.destination).length == 0)) {
									this.ancillaries[x].quantity = this.ancillaries[x].quantity + ancillaryDetails.quantity;
									this.ancillaries[x].cost = parseFloat(this.ancillaries[x].cost) + parseFloat(ancillaryDetails.cost);
									this.ancillaries[x].points = parseInt(this.ancillaries[x].points) + parseInt(ancillaryDetails.points);
								}
								ancillariesTemp.push(ancillaryDetails);
							}
							else if (this.ancillaries[x].type === EXTRAS_ANCILLARY_BAG && ancillaryDetails.type === EXTRAS_ANCILLARY_BAG) {
								if ((ancillariesTemp.filter(anc => anc.type === EXTRAS_ANCILLARY_BAG && anc.destination == ancillaryDetails.destination).length > 0) &&
									(ancillariesTemp.filter(anc => anc.type === EXTRAS_ANCILLARY_BAG && anc.paxId == ancillaryDetails.paxId &&
										anc.code == ancillaryDetails.code && anc.destination == ancillaryDetails.destination).length == 0)) {
									this.ancillaries[x].quantity = this.ancillaries[x].quantity + ancillaryDetails.quantity;
									this.ancillaries[x].cost = parseFloat(this.ancillaries[x].cost) + parseFloat(ancillaryDetails.cost);
									this.ancillaries[x].points = parseInt(this.ancillaries[x].points) + parseInt(ancillaryDetails.points);
								} else {
									if (ancillaryDetails.code === SSR_CODE_BAGGAGE_ADDITIONAL_BAG &&
										(ancillariesTemp.filter(anc => anc.type === EXTRAS_ANCILLARY_BAG && anc.destination == ancillaryDetails.destination &&
											anc.paxId == ancillaryDetails.paxId && anc.code == ancillaryDetails.code).length > 0) &&
										(ancillariesTemp.filter(anc => anc.type === EXTRAS_ANCILLARY_BAG && anc.destination == ancillaryDetails.destination &&
											anc.paxId == ancillaryDetails.paxId && anc.code == ancillaryDetails.code && ((anc.emdTicket && anc.emdTicket == ancillaryDetails.emdTicket) ||
												(anc.ssrTatto && anc.ssrTatto == ancillaryDetails.ssrTatto))).length == 0)) {
										this.ancillaries[x].quantity = this.ancillaries[x].quantity + ancillaryDetails.quantity;
										this.ancillaries[x].cost = parseFloat(this.ancillaries[x].cost) + parseFloat(ancillaryDetails.cost);
										this.ancillaries[x].points = parseInt(this.ancillaries[x].points) + parseInt(ancillaryDetails.points);
									}
								}
								ancillariesTemp.push(ancillaryDetails);
							}
							else if (ANCILLARY_PRODUCT_PACKS.includes(this.ancillaries[x].type) && this.ancillaries[x].flightBased && ANCILLARY_PRODUCT_PACKS.includes(ancillaryDetails.type)) {
								if ((ancillariesTemp.filter(anc => ANCILLARY_PRODUCT_PACKS.includes(anc.type) && anc.destination == ancillaryDetails.destination).length > 0) &&
								(ancillariesTemp.filter(anc => ANCILLARY_PRODUCT_PACKS.includes(anc.type) && anc.paxId == ancillaryDetails.paxId &&
									anc.code == ancillaryDetails.code && anc.destination == ancillaryDetails.destination).length == 0)) {
										this.ancillaries[x].quantity = this.ancillaries[x].quantity + ancillaryDetails.quantity;
										this.ancillaries[x].cost = parseFloat(this.ancillaries[x].cost) + parseFloat(ancillaryDetails.cost);
										this.ancillaries[x].points = parseInt(this.ancillaries[x].points) + parseInt(ancillaryDetails.points);
								}
								ancillariesTemp.push(ancillaryDetails);

							}

							else {
								if (this.ancillaries[x].type !== EXTRAS_ANCILLARY_ANIMAL && ancillaryDetails.type !== EXTRAS_ANCILLARY_ANIMAL &&
									this.ancillaries[x].type !== EXTRAS_ANCILLARY_EQUIPMENT && ancillaryDetails.type !== EXTRAS_ANCILLARY_EQUIPMENT &&
									this.ancillaries[x].type !== EXTRAS_ANCILLARY_MUSICAL && ancillaryDetails.type !== EXTRAS_ANCILLARY_MUSICAL &&
									this.ancillaries[x].type !== EXTRAS_ANCILLARY_BAG && ancillaryDetails.type !== EXTRAS_ANCILLARY_BAG || 
									(ANCILLARY_PRODUCT_PACKS.includes(this.ancillaries[x].type) && !this.ancillaries[x].flightBased && ANCILLARY_PRODUCT_PACKS.includes(ancillaryDetails.type))) {
									this.ancillaries[x].quantity = this.ancillaries[x].quantity + 1;
									this.ancillaries[x].cost = parseFloat(this.ancillaries[x].cost) + parseFloat(ancillaryDetails.cost);
									this.ancillaries[x].points = parseInt(this.ancillaries[x].points) + parseInt(ancillaryDetails.points);
								}
							}
						}
					}
					if (!found) {
						this.ancillaries.push(ancillaryDetails);
						ancillariesTemp.push(ancillaryDetails);
					}
				}
			}
		}
	}

	INDRA_getAdminFee(pnrDetails) {
		return pnrDetails && pnrDetails.data && pnrDetails.data.fare && pnrDetails.data.fare.flightPrice
			&& pnrDetails.data.fare.flightPrice.totalPrice && pnrDetails.data.fare.flightPrice.totalPrice.adminFee
			&& pnrDetails.data.fare.flightPrice.totalPrice.adminFee.amount && pnrDetails.data.fare.flightPrice.totalPrice.adminFee.active ?
			pnrDetails.data.fare.flightPrice.totalPrice.adminFee.amount : 0;
	}

	INDRA_getSurchargeAmount(pnrDetails) {
		return pnrDetails && pnrDetails.data && pnrDetails.data.fare && pnrDetails.data.fare.flightPrice
			&& pnrDetails.data.fare.flightPrice.totalPrice && pnrDetails.data.fare.flightPrice.totalPrice.ccFee ?
			pnrDetails.data.fare.flightPrice.totalPrice.ccFee : 0;
	}

	INDRA_isMilesLoyaltyProgramAwardTicket() {
		return this.bookingService.INDRA_isAward(this.booked_trip);
	}

	INDRA_printAirlineLogo(flights) {
		if (flights) {
			const busSegmentCount = flights.listSegment.filter(segment => segment.equipment === EQUIPMENT_CODE_BUS).length;
			if (busSegmentCount > 0) {
				this.airlineLogo = 'Bus';
				return 'icons.svg#plane_related--plane_and_bus';
			} else {
				if (flights.listSegment.length > 1) {
					const ALL_SAME_AIRLINE = flights.listSegment.every((val, i, arr) => val.operationCarrier === arr[0].operationCarrier);

					if (ALL_SAME_AIRLINE) {
						this.airlineLogo = flights.listSegment[0].operationCarrier;
					} else {
						this.airlineLogo = 'Multiple';
					}
				} else {
					this.airlineLogo = flights.listSegment[0].operationCarrier;
				}
				return this.bookingSearchService.INDRA_buildAirlineLogoName(this.airlineLogo);
			}
		} else {
			this.airlineLogo = 'not_found';
			return this.bookingSearchService.INDRA_buildAirlineLogoName(this.airlineLogo);
		}
	}

	INDRA_printFlightDate(flight): string {
		if (flight) {
			const date = moment(new Date(flight.listSegment[0].departureDate.slice(0, -5)));

			const dateTime = date.format('D - kk:mm');
			let day = date.format('dddd').toLowerCase();
			let month = date.format('MMMM').toLowerCase();

			day = this.INDRA_getTranslation('dates.text.' + day);
			month = this.INDRA_getTranslation('dates.text.' + month);

			return `${day.substring(0, 3)}, ${month.substring(0, 3)} ${dateTime}`;
		}
	}

	INDRA_getPrice(priceOf) {
		const fare = this.flightPriceService.INDRA_getFlightFareBreakdown();
		const totalObfee = fare.summary && fare.summary.totalObfee ? fare.summary.totalObfee : 0;
		const totalTax = fare.summary && fare.summary.totalTax ? fare.summary.totalTax : 0;
		const totalFare = fare.summary && fare.summary.totalFare ? fare.summary.totalFare : 0;

		let flightMiles = fare.summary && fare.summary.totalMiles ? fare.summary.totalMiles : 0;
		let flightCash = totalObfee + totalTax + totalFare;
		let flightCurrency = fare.currency ? fare.currency : this.currency;

		// override flight price and tax from fare breakdown API when: 
		// (1) there is both totalPrice.basePrice and totalPoints.price in bookedTrip, or
		// (2) if the flight is a commercial booking
		// (2) if the booking is an award booking. 
		// Notes re (1): having values for these two (totalPrice.basePrice and totalPoints.price) that miles&go discount were availed for the flight prices
		// Notes re (2): if the booking is an award booking, we need to use the values from generate APi since farebreakdown API does not return the obfee value.
		if (this.booked_trip && this.booked_trip.data.fare && this.booked_trip.data.fare.flightPrice) {
			const totalPrice = this.booked_trip.data.fare.flightPrice.totalPrice;
			const totalPoints = this.booked_trip.data.fare.flightPrice.totalPoints;
			if (totalPrice && totalPoints && totalPrice.basePrice && totalPoints.price && !this.isAwardTicket) {
				const tax = totalPrice.tax;
				const basePriceInCash = totalPrice.basePrice;
				const basePriceInPoints = totalPoints.price;
				flightCash = basePriceInCash + tax;
				flightMiles = basePriceInPoints;
			}

			if (totalPrice && (totalPoints === null || (totalPoints && totalPoints.price == 0)) && totalPrice.basePrice && !this.isAwardTicket) {
				flightCash = totalPrice.price;
			}

			if (totalPrice && totalPoints && totalPrice.tax && totalPoints.price && this.isAwardTicket) {
				const obFee = totalPrice['obFee'] ? totalPrice['obFee'] : 0;
				const basePriceInCash = totalPrice.tax + obFee;
				const basePriceInPoints = totalPoints.price;
				flightCash = basePriceInCash;
				flightMiles = basePriceInPoints;
			}

			// if basePrice == 0 and has slider discount and tax
			if (totalPrice && totalPoints && totalPrice.basePrice == 0 && totalPrice.tax && totalPoints.price && !this.isAwardTicket) {
				const tax = totalPrice.tax;
				const basePriceInPoints = totalPoints.price;
				flightCash = tax;
				flightMiles = basePriceInPoints;
			}
		}

		switch (priceOf) {
			case 'flights':
				return flightMiles ? `${flightMiles}M + ${flightCash}${flightCurrency}` : `${flightCash}${flightCurrency}`;
			case 'ancillaries':
				let totalAncillaries = 0;
				let totalAncillaryPoints = 0;
				let totalAncillariesCurrency = '';
				this.ancillaries.forEach(ancillary => {
					totalAncillaries += +ancillary.cost;
					totalAncillaryPoints += ancillary.points;
					totalAncillariesCurrency = ancillary.currency;
				});

				if (this.paidThirdPartyAncillaries.length) this.paidThirdPartyAncillaries.forEach(ancillary => totalAncillaries += +ancillary.amount);
				if (this.extra_stopover.length) this.extra_stopover.forEach(extra => totalAncillaries += +extra.value);

				return totalAncillaryPoints ? `${totalAncillaryPoints}M + ${totalAncillaries}${totalAncillariesCurrency}` : totalAncillaries + totalAncillariesCurrency;

			case 'extras':
				let totalExtras = 0;
				let totalExtrasCurrency = '';
				this.boughtHotelBookingExtras.forEach(extra => {
					totalExtras += +extra.value;
					totalExtrasCurrency = extra.currency;
				})

				return `${totalExtras} ${totalExtrasCurrency}`;

			case 'discounts':
				let totalDiscount = '';
				if (this.booked_trip.data.fare.totalDiscount) {
					let cashPart = '';
					const milesPart = this.booked_trip.data.fare.totalDiscount.miles > 0 ? `${this.booked_trip.data.fare.totalDiscount.miles.toFixed(0)} M` : '';
					if (this.booked_trip.data.fare.totalDiscount.amount > 0 && this.booked_trip.data.fare.totalDiscount.miles > 0) {
						cashPart = `+ ${this.booked_trip.data.fare.totalDiscount.amount.toFixed(2)} ${this.currencyService.INDRA_getCurrencySymbol(this.booked_trip.data.fare.totalDiscount.currency).unit}`;
					} else if (this.booked_trip.data.fare.totalDiscount.amount > 0 && this.booked_trip.data.fare.totalDiscount.miles <= 0) {
						cashPart = `${this.booked_trip.data.fare.totalDiscount.amount.toFixed(2)} ${this.currencyService.INDRA_getCurrencySymbol(this.booked_trip.data.fare.totalDiscount.currency).unit}`;
					} else {
						cashPart = '';
					}
					totalDiscount = `${milesPart} ${cashPart}`;
				}
				return totalDiscount;

			case 'adminFee':
				return this.adminFee;

			case 'ccFee':
				return this.surchargeAmount;

			case 'otherCharges':
				return this.adminFee + this.surchargeAmount;

			// case 'finalAmountWithDiscounts':
			// 	return this.flightPriceService.INDRA_getBookingTotalCost(
			// 		this.booked_trip.flights, this.booked_trip.booking_type, this.bookAwardFlights, false,
			// 		this.promocoCodesAndVoucher, this.bookedTripDiscounts, this.weakFlightsDiscount, this.ancillaryList, this.extra_stopover);
			// case 'finalAmountWithDiscountsAndNoMilesGo':
			// 	if (!this.isDupe) {
			// 		return this.flightPriceService.INDRA_getBookingTotalCost(
			// 			this.booked_trip.flights, this.booked_trip.booking_type, this.bookAwardFlights, true,
			// 			this.promocoCodesAndVoucher, this.bookedTripDiscounts, this.weakFlightsDiscount, this.ancillaryList, this.extra_stopover);
			// 	} else {
			// 		return this.INDRA_formatCash(this.dupe_booked_trip.data.fare.flightPrice.totalPrice.price);
			// 	}

			case 'total':
				let totalCost = flightCash + this.adminFee + this.surchargeAmount;
				let totalPoints = flightMiles;

				if (this.ancillaries.length) this.ancillaries.forEach(ancillary => { totalCost += +ancillary.cost; totalPoints += ancillary.points; });
				if (this.paidThirdPartyAncillaries.length) this.paidThirdPartyAncillaries.forEach(ancillary => totalCost += +ancillary.amount);
				if (this.extra_stopover.length) this.extra_stopover.forEach(extra => totalCost += +extra.value);
				if (this.discounts.length) {

					// check if has flightPrice, this price is already discount lessed
					if (!(this.booked_trip && this.booked_trip.data.fare && this.booked_trip.data.fare.flightPrice
						&& (this.booked_trip.data.fare.flightPrice['totalPrice'] || this.booked_trip.data.fare.flightPrice['totalPoints']))) {
						this.discounts.forEach(discount => {
							if (discount.currency === 'FFP') {
								totalPoints -= discount.amount
							} else {
								totalCost -= +discount.amount
							}
						});
					}
				}

				totalCost = totalPoints ? `${totalPoints}M + ${totalCost}${flightCurrency}` : `${totalCost}${flightCurrency}`;

				return totalCost;

			default:
				return '';
		}
	}

	INDRA_handleFareAndTaxes() {
		let fareTaxesParams = {
			isDupe: false
		};

		// if PNR is passed to the fare and taxes sidebar, the taxes will be retrieved using PNR, else will be retrieved from backend session
		if (this.isTaxSidebarByPNR == 'true' || this.isTaxSidebarByPNR == '' || this.isTaxSidebarByPNR == null || this.isTaxSidebarByPNR == undefined) {
			fareTaxesParams['pnr'] = this.pnr
		}

		this.sidebarService.openSidebar(['fare-and-taxes', fareTaxesParams]);
	}

	INDRA_getDiscounts(bookedTripDiscounts) {
		let discounts = [];
		if (bookedTripDiscounts && bookedTripDiscounts.length) {
			// discounts are divided into the bound flights evenly thus a discount will be returned separately 
			// with divided amounts but hte same id if the booking ahs more than 1 flight
			bookedTripDiscounts.forEach(discount => {

				// if discount is percentage "discounts" will return percent in amount instead of actual value
				// lookup data.fare.promocodeVouchers to get actual amount that matches discount id/code
				if (discount.amountType == 'PERCENTAGE' && this.booked_trip.data.fare['promocodeVouchers']) {
					const promoVoucher = this.booked_trip.data.fare.promocodeVouchers.find(promo =>promo.code == discount.id);
					if (promoVoucher && discount.amount != promoVoucher.amount) {
						discount.amount = promoVoucher.amount
					}
				}

				let amount = discount.amount;

				let existing = discounts.find(data => {
					return data.id == discount.id;
				});


				if (existing) {
					var existingIndex = discounts.findIndex(data => data.id == existing.id);
					discounts[existingIndex] = {
						amount: discounts[existingIndex].amount + amount,
						currency: discounts[existingIndex].currency,
						id: discounts[existingIndex].id,
						paxId: discounts[existingIndex].paxId,
						type: discounts[existingIndex].type
					}
				}
				else {
					discounts.push(discount);
				}
			});
		}
		return discounts;
	}

	INDRA_showExtras() {
		let showExtras: boolean = false;
		if (this.ancillaries.length || this.paidThirdPartyAncillaries.length || this.extra_stopover.length) {
			showExtras = true;
		}

		return showExtras;
	}

	INDRA_getAncillaries() {
		const ancillaries = [];
		const existingEMDList = [];
		if (this.booked_trip.data.ancillaries) {
			Object.keys(this.booked_trip.data.ancillaries).forEach(type => {
				const items: [] = this.booked_trip.data.ancillaries[type].length > 0 ? this.booked_trip.data.ancillaries[type] : [this.booked_trip.data.ancillaries[type]];
				items.forEach((item: any) => {
					if ((type === 'ancillaries' && item.ancillaryType !== EXTRAS_ANCILLARY_SEAT) || type === 'seat' || type === 'packs') {
						let ancillary: any = {};
						ancillary.type = item.ancillaryType;
						if (item.journey && item.journey.length) {
							item.journey.forEach((flight: any) => {
								const details: any = {
									flightId: flight.flightId,
									segmentId: flight.segmentId,
									flightBased: flight.flightBased
								};
								if (flight.passengers && flight.passengers.length) {
									flight.passengers.forEach((pax: any) => {
										details.paxId = pax.paxId;
										if (pax.ancillaryInfo && pax.ancillaryInfo.length) {
											pax.ancillaryInfo.forEach((info: any) => {
												//if (info.emdTicket /* && !existingEMDList.includes(info.emdTicket) */ || info.code === EXTRAS_ANCILLARY_SEAT) {
												ancillary = { ...ancillary, ...details, ...info };

												if (info.code === EXTRAS_ANCILLARY_SEAT) {
													ancillary.type = info.code;
												}

												ancillaries.push(ancillary);
												existingEMDList.push(info.emdTicket);
												//}
											});
										}
									});
								}
							});
						}
					}
				});
			});
		}
		return ancillaries;
	}

	INDRA_getFlightDetails(flightDetails, ancillaryData) {
		let flightData: any;
		for (const i in flightDetails) {
			if (flightDetails[i].type == 'flight') {
				if (flightDetails[i].item.details.idFlight == parseInt(ancillaryData.flightId)) {
					flightData = Object.assign({}, flightDetails[i].item.details);
					break;
				}
			}
		}
		return flightData;
	}

	INDRA_setBoughtPartnerExtras() {
		if (this.booked_trip && this.booked_trip.externalReservations) {

			if (this.booked_trip.externalReservations[EXTRAS_ANCILLARY_CARBON_OFFSET] &&
				this.booked_trip.externalReservations[EXTRAS_ANCILLARY_CARBON_OFFSET].length > 0) {
				let boughtCarbonOffsetStatus = this.booked_trip.externalReservations[EXTRAS_ANCILLARY_CARBON_OFFSET][0].status;
				if (boughtCarbonOffsetStatus != 'KO' && boughtCarbonOffsetStatus != null) {
					this.boughtCarbonOffsetExtra = this.booked_trip.externalReservations[EXTRAS_ANCILLARY_CARBON_OFFSET][0];
					this.carbonOffsetCurrency = this.currencyService.INDRA_getCurrencySymbol(this.boughtCarbonOffsetExtra.currency).unit;
					this.paidThirdPartyAncillaries.push(this.boughtCarbonOffsetExtra);
				}
			}

			if (this.booked_trip.externalReservations[EXTRAS_ANCILLARY_BOOKING_HOTEL] &&
				this.booked_trip.externalReservations[EXTRAS_ANCILLARY_BOOKING_HOTEL].length > 0) {
				this.booked_trip.externalReservations[EXTRAS_ANCILLARY_BOOKING_HOTEL].forEach(data => {
					if (data.status != 'KO' && data.status != null) {
						const hotel = {
							city: data.extraInfo ? this.bookingService.INDRA_getLocation(data.extraInfo.city).city : '',
							value: data.amount,
							currency: this.currencyService.INDRA_getCurrencySymbol(data.currency).unit
						}
						this.boughtHotelBookingExtras.push(hotel);
					}
				});

			}

			if (this.booked_trip.externalReservations['DANISH_FUND'] &&
				this.booked_trip.externalReservations['DANISH_FUND'].length > 0) {
				let boughtDanishFundStatus = this.booked_trip.externalReservations['DANISH_FUND'][0].status;

				if (boughtDanishFundStatus != 'KO' && boughtDanishFundStatus != null) {
					this.boughtDanishFundExtra = this.booked_trip.externalReservations['DANISH_FUND'][0];
					this.danishFundCurrency = this.currencyService.INDRA_getCurrencySymbol(this.boughtDanishFundExtra.currency).unit;
					this.paidThirdPartyAncillaries.push(this.boughtDanishFundExtra);
				}
			}

			if (this.booked_trip.externalReservations['CHUBB'] &&
				this.booked_trip.externalReservations['CHUBB'].length > 0) {
				// let boughtTravelInsuranceStatus = this.booked_trip.externalReservations['CHUBB'][0].status;

				// if (boughtTravelInsuranceStatus != 'KO' && boughtTravelInsuranceStatus != null) {
					this.boughtTravelInsuranceExtra = this.booked_trip.externalReservations['CHUBB'][0];
					this.insuranceCurrency = this.currencyService.INDRA_getCurrencySymbol(this.boughtTravelInsuranceExtra.currency).unit;
					this.paidThirdPartyAncillaries.push(this.boughtTravelInsuranceExtra);
				// }
			}

			if (this.booked_trip.externalReservations['CARTRAWLER'] &&
				this.booked_trip.externalReservations['CARTRAWLER'].length > 0) {
				let boughtCarRentalStatus = this.booked_trip.externalReservations['CARTRAWLER'][0].status;

				if (boughtCarRentalStatus != 'KO' && boughtCarRentalStatus != null) {
					this.boughtCarRentalExtra = this.booked_trip.externalReservations['CARTRAWLER'][0];
					this.carRentalCurrency = this.currencyService.INDRA_getCurrencySymbol(this.boughtCarRentalExtra.currency).unit;
					this.carRentalCity = this.booked_trip.translate.locations[this.boughtCarRentalExtra.extraInfo.city].city
					this.paidThirdPartyAncillaries.push(this.boughtCarRentalExtra);
				}
			}

			if (this.booked_trip.externalReservations.SO_AIRPORT_TRANSFER &&
				this.booked_trip.externalReservations.SO_AIRPORT_TRANSFER.length > 0) {
				const extraAncillary = this.booked_trip.externalReservations.SO_AIRPORT_TRANSFER[0];
				if (extraAncillary.status != 'KO' && extraAncillary.status != null) {
					const extraDetails = this.STOPOVER_LINKS.find(extra => extra.id == 'airport-transfers');
					const extraAncillaryAmount = extraAncillary.stopOverInfo.SO_AIRPORT_TRANSFER.amount;
					const currency = this.currencyService.INDRA_getCurrencySymbol(extraAncillary.stopOverInfo.SO_AIRPORT_TRANSFER.currency).unit;

					this.INDRA_createStopoverExtra(extraDetails, extraAncillary, extraAncillaryAmount, currency);
				}
			}

			if (this.booked_trip.externalReservations.SO_LISBON_DISCOUNT &&
				this.booked_trip.externalReservations.SO_LISBON_DISCOUNT.length > 0) {
				const extraAncillary = this.booked_trip.externalReservations.SO_LISBON_DISCOUNT[0];
				if (extraAncillary.status != 'KO' && extraAncillary.status != null) {
					const extraDetails = this.STOPOVER_LINKS.find(extra => extra.id == 'lisboa-card');
					const extraAncillaryAmount = extraAncillary.stopOverInfo.SO_LISBON_DISCOUNT.amount;
					const currency = this.currencyService.INDRA_getCurrencySymbol(extraAncillary.stopOverInfo.SO_LISBON_DISCOUNT.currency).unit;

					this.INDRA_createStopoverExtra(extraDetails, extraAncillary, extraAncillaryAmount, currency);
				}
			}

			if (this.booked_trip.externalReservations.SO_SIGHTSEEING_TOUR &&
				this.booked_trip.externalReservations.SO_SIGHTSEEING_TOUR.length > 0) {
				const extraAncillary = this.booked_trip.externalReservations.SO_SIGHTSEEING_TOUR[0];
				if (extraAncillary.status != 'KO' && extraAncillary.status != null) {
					const extraDetails = this.STOPOVER_LINKS.find(extra => extra.id == 'sightseeing-tours');
					let extraAncillaryAmount = 0;
					let currency = '';
					for (const i in extraAncillary.stopoverInfo) {
						extraAncillaryAmount += extraAncillary.stopOverInfo[i].amount;
						currency = this.currencyService.INDRA_getCurrencySymbol(extraAncillary.stopOverInfo[i].currency).unit;

					}
					this.INDRA_createStopoverExtra(extraDetails, extraAncillary, extraAncillaryAmount, currency);
				}
			}

			// this.hasBoughtPartnerExtras = (this.boughtCarbonOffsetExtra || this.boughtHotelBookingExtras || this.boughtDanishFundExtra != null || this.boughtTravelInsuranceExtra != null) ? true : false;
		}
	}

	INDRA_createStopoverExtra(extraDetails, extraAncillary, extraAncillaryAmount, currency) {
		this.extra_stopover.push(Object.assign({}, {
			icon: extraDetails.icon,
			action: extraDetails.action,
			label: extraDetails.label,
			stopoverCityName: this.booked_trip.translate.locations[extraAncillary.idReservation].city,
			value: extraAncillaryAmount,
			currency: currency
		}));
	}

	INDRA_getLabelTranslation(lastKey: string, type?: string) {
		const key = 'priceBreakdown.' + type + '.' + lastKey.toLowerCase();
		return key;
	}

	INDRA_printExtraCost(extra) {
		if (extra.payWithMiles) {
			return this.INDRA_formatMiles(extra.points);
		} else {
			return this.INDRA_formatCash(+extra.cost, extra.currency);
		}
	}

	INDRA_formatMiles(value) {
		return value.toFixed(0) + ' M';
	}

	INDRA_formatCash(value, currency?) {
		const currencyToDisplay = currency ? currency : this.currency;
		return value.toFixed(2) + ' ' + currencyToDisplay;
	}

	INDRA_handleDetailsClick(flight) {
		this.sidebarService.openSidebar(['flight-details', { flight: flight.item.details.assignedFlightId }]);
	}

	INDRA_getTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

	/* END PRICE BREAKDOWN BOOKING VIEW */

	INDRA_getPlanDescription(key: string) {
		if (key) {
			const label = this.ibeAdminService.getTranslationValue(`${this.translationInsurance.MODULE}.${this.translationInsurance.PROVIDER}.${this.translationInsurance.PLAN}.${key}`);
			return label;
		}
		return '';
	}
}
